import { isEmpty, isString, isObject } from 'lodash';

/**
 * @type {function}
 * @desc This utlity function helps to bind and unbind scroll events.
 * @example
 * import * as scrollListener from 'utils/scrollListener';
 * scrollListener.listen( ...args );
 */
export const listen = ( node, callback ) => {

    // listen to scroll event
    if( ! isEmpty( node ) && isString( node ) && document.querySelector( node ) ) {
        document.querySelector( node ).addEventListener( 'scroll', callback );
    } else if( ! isEmpty( node ) && isObject( node ) ) {
        node.addEventListener( 'scroll', callback );
    } else {
        window.addEventListener( 'scroll', callback );
    }
};

export const unlisten = ( node, callback ) => {

    // unlisten to scroll event
    if( ! isEmpty( node ) && isString( node ) && document.querySelector( node ) ) {
        document.querySelector( node ).removeEventListener( 'scroll', callback );
    } else if( ! isEmpty( node ) && isObject( node ) ) {
        node.removeEventListener( 'scroll', callback );
    } else {
        window.removeEventListener( 'scroll', callback );
    }
};
